<template>
  <!-- 打卡记录 -->
  <div class="clockInRecord">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
      <!-- <el-button type="primary" size="mini" icon="el-icon-download" @click="derive">导出考勤表</el-button> -->
      <ExportExcelDaka :info="tableData" />
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="企业名称：" prop="companyName">
        <el-input v-model="screenForm.companyName" />
      </el-form-item>
      <el-form-item label="账号：" prop="username">
        <el-input v-model="screenForm.username" />
      </el-form-item>
      <el-form-item label="真实姓名：" prop="name">
        <el-input v-model="screenForm.name" />
      </el-form-item>
      <el-form-item label="联系方式：" prop="contact">
        <el-input v-model="screenForm.contact" />
      </el-form-item>
      <el-form-item label="打卡日期：" prop="punchDate">
        <el-input v-model="screenForm.punchDate" />
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData"> 筛选 </el-button>
    </el-form>
    <!-- 列表 -->
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        tooltip-effect="dark"
        :stripe="true"
        :border="true"
        size="mini"
      >
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="企业名称">
          <template slot-scope="scope">
            <div v-if="scope.row.company">
              <div>{{ scope.row.company.companyName }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="company.username" label="账号" />
        <el-table-column prop="company.zhiwei" label="职位" />
        <el-table-column prop="company.contact" label="联系方式" />
        <el-table-column prop="company.name" label="真实姓名" />
        <el-table-column prop="time" label="打卡记录">
          <template slot-scope="scope">
            <div v-if="scope.row.time1">
              <span>第1次：</span>
              <span>{{ scope.row.time1 }}</span>
              <span style="margin-left: 5px">{{ scope.row.punchStatus1 == 0 ? '正常' : scope.row.punchStatus1 == 1 ? '外勤' : '缺卡' }}</span>
              <span style="margin-left: 5px">{{ scope.row.punchType1 == 0 ? '出勤打卡' : scope.row.punchType1 == 1 ? '外勤打卡' : '未打卡' }}</span>
            </div>
            <div v-if="scope.row.time2">
              <span>第2次：</span>
              <span>{{ scope.row.time2 }}</span>
              <span style="margin-left: 4px">{{ scope.row.punchStatus2 == 0 ? '正常' : scope.row.punchStatus2 == 1 ? '外勤' : '缺卡' }}</span>
              <span style="margin-left: 4px">{{ scope.row.punchType2 == 0 ? '出勤打卡' : scope.row.punchType2 == 1 ? '外勤打卡' : '未打卡' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="poiAddress" label="打卡定位地理">
          <template slot-scope="scope">
            <div v-if="scope.row.poiAddress1">
              <span>第1次：</span>
              <span>{{ scope.row.poiAddress1 }}</span>
            </div>
            <div v-if="scope.row.poiAddress2">
              <span>第2次：</span>
              <span>{{ scope.row.poiAddress2 }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="打卡照片" width="100">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.onPunchImageUrl1" :key="item + index + 1">
              <el-image v-if="matchType(item) == 2" :src="item" style="width: 70px; height: 70px; border-radius: 8px" @click="previewImage(item)" />
              <video v-if="matchType(item) == 8" style="width: 70px; height: 70px; border-radius: 8px" :src="item" :controls="true" />
            </div>
            <div v-for="(item, index) in scope.row.onPunchImageUrl2" :key="item + index">
              <el-image v-if="matchType(item) == 2" :src="item" style="width: 70px; height: 70px; border-radius: 8px" @click="previewImage(item)" />
              <video v-if="matchType(item) == 8" style="width: 70px; height: 70px; border-radius: 8px" :src="item" :controls="true" />
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="账号状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status === 0" style="color: #67c23a">正常</div>
            <div v-else-if="scope.row.status === 1" style="color: #e6a23c">已禁用</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
            <div v-if="scope.row.remark1">
              {{ scope.row.remark1 }}
            </div>
            <div v-if="scope.row.remark2">
              {{ scope.row.remark2 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="punchDate" label="打卡日期" />
      </el-table>
      <!-- 分页 -->
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import ExportExcelDaka from '@/components/ExportExcelDaka/record.vue'
import pagination from '@/mixins/pagination'
import { deepClone } from '@/utils'
export default {
  components: { ExportExcelDaka },
  mixins: [pagination],
  data() {
    return {
      screenForm: {
        companyName: '',
        username: '',
        name: '',
        contact: '',
        punchDate: ''
      },
      loading: true,
      tableData: [],
      tableH: 0
    }
  },
  mounted() {
    this.getTableList() // 获取企业打卡管理列表
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    // 刷新
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
        })
        .catch(() => {})
    },
    // 导出考勤表
    derive() {},
    // 筛选
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      Promise.all([this.getTableList()])
        .then(() => {
          this.loading = false
        })
        .catch(() => {})
    },
    // 打卡记录列表
    getTableList() {
      this.loading = true
      return this.$api.clockIn
        .getPunchLogList(this.page)
        .then((res) => {
          console.log(res)
          this.tableData = res.records
          // this.tableData[0].onPunchImageUrl1 = []
          // this.tableData[0].onPunchImageUrl1.push('https://hgz.qn.fshgz.com/default_16667977515875604688137.jpg')
          // this.tableData[0].onPunchImageUrl1.push('https://hgz.qn.fshgz.com/default_16667977515875604688137.jpg')
          this.total = res.total
          const ids = this.tableData
            .filter((item) => item.companyAccountId)
            .map((item) => item.companyAccountId)
            .join(',')
          console.log(ids)
          this.getFindCompanyByIds({ ids }) // 所在公司
          // this.getCompanyList({ ids }) // 账号管理ids接口
        })
        .catch((e) => {})
    },
    // 所在公司
    getFindCompanyByIds(data) {
      console.log(data)
      this.$api.common
        .reqCompanyAccountByIds(data)
        .then((res) => {
          // console.log(res)
          const arr = Object.keys(res)
          if (arr.length == 0) return (this.loading = false)
          const settingObj = res
          const settingArr = Object.keys(settingObj).map((key) => {
            // console.log(key); //为每个键名
            console.log(settingObj)
            return settingObj[key] // 把每个对象返回出去生成一个新的数组中相当于0:{id:1}
          })
          console.log(settingArr)
          const companyList = settingArr
          const map = new Map()
          companyList.forEach((item) => {
            map[item.id] = item
          })
          this.tableData.forEach((item) => {
            item.company = map[item.companyAccountId]
          })
          this.tableData = JSON.parse(JSON.stringify(this.tableData))
          console.log(this.tableData)
          this.loading = false
        })
        .catch((e) => {
          console.error(e)
          this.loading = false
        })
    },
    // 判断类型
    // 根据文件名后缀区分 文件类型
    /*
     * @param: fileName - 文件名称
     * @param: 数据返回 1) 无后缀匹配 - false
     * @param: 数据返回 2) 匹配图片 - image
     * @param: 数据返回 3) 匹配 txt - txt
     * @param: 数据返回 4) 匹配 excel - excel
     * @param: 数据返回 5) 匹配 word - word
     * @param: 数据返回 6) 匹配 pdf - pdf
     * @param: 数据返回 7) 匹配 ppt - ppt
     * @param: 数据返回 8) 匹配 视频 - video
     * @param: 数据返回 9) 匹配 音频 - radio
     * @param: 数据返回 10) 其他匹配项 - other
     */
    matchType(fileName) {
      // 后缀获取
      let suffix = ''
      // 获取类型结果
      let result = ''
      try {
        const fileArr = fileName.split('.')
        suffix = fileArr[fileArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false
        return 1
      }
      // 图片格式
      const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'image'
        return 2
      }
      // 匹配txt
      const txtList = ['txt']
      result = txtList.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'txt'
        return 3
      }
      // 匹配 excel
      const excelist = ['xls', 'xlsx']
      result = excelist.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'excel'
        return 4
      }
      // 匹配 word
      const wordlist = ['doc', 'docx']
      result = wordlist.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'word'
        return 5
      }
      // 匹配 pdf
      const pdflist = ['pdf']
      result = pdflist.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'pdf'
        return 6
      }
      // 匹配 ppt
      const pptlist = ['ppt']
      result = pptlist.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'ppt'
        return 7
      }
      // 匹配 视频
      const videolist = ['mp4', 'm2v', 'mkv']
      result = videolist.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'video'
        return 8
      }
      // 匹配 音频
      const radiolist = ['mp3', 'wav', 'wmv']
      result = radiolist.some(function(item) {
        return item == suffix
      })
      if (result) {
        result = 'radio'
        return 9
      }
      // 其他 文件类型
      result = 'other'
      return 10
    }
  }
}
</script>

<style lang="scss" scoped>
.clockInRecord {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
